import { useState } from 'react'
import { useOrganization, useUpdateOrganization } from '../../hooks/useOrganization'
import { useAuth } from '../../auth/AuthContext'

export function OrganizationInfoSection() {
  const { data: organization, isLoading: orgLoading } = useOrganization()
  const { user } = useAuth()
  const [editingOrg, setEditingOrg] = useState(false)
  const [orgName, setOrgName] = useState('')
  const [orgDescription, setOrgDescription] = useState('')
  const updateOrganization = useUpdateOrganization()

  return (
    <div>
      <div className="section-header">
        <div>
          <h2 className="section-title">組織設定</h2>
          <p className="text-sm text-secondary" style={{ marginTop: 'var(--space-1)' }}>
            組織の基本情報と設定
          </p>
        </div>
        {user?.role === 'admin' && !editingOrg && (
          <button
            onClick={() => {
              setEditingOrg(true)
              setOrgName(organization?.name || '')
              setOrgDescription(organization?.description || '')
            }}
            className="btn btn-outline"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z" />
            </svg>
            編集
          </button>
        )}
      </div>

      {orgLoading ? (
        <div className="card text-center" style={{ padding: 'var(--space-12)' }}>
          <span className="spinner lg" style={{ margin: '0 auto' }} />
          <p className="text-sm text-secondary" style={{ marginTop: 'var(--space-3)' }}>読み込み中...</p>
        </div>
      ) : organization ? (
        <div className="card">
          <div className="form-group">
            <label className="form-label">組織名</label>
            <input
              type="text"
              value={editingOrg ? orgName : organization.name}
              onChange={(e) => setOrgName(e.target.value)}
              disabled={!editingOrg}
              className="form-input"
              style={!editingOrg ? { background: 'var(--color-surface)', color: 'var(--color-text-secondary)', cursor: 'not-allowed' } : undefined}
            />
          </div>

          <div className="form-group">
            <label className="form-label">説明</label>
            <textarea
              value={editingOrg ? orgDescription : (organization.description || '')}
              onChange={(e) => setOrgDescription(e.target.value)}
              disabled={!editingOrg}
              rows={3}
              className="form-input"
              style={!editingOrg ? { background: 'var(--color-surface)', color: 'var(--color-text-secondary)', cursor: 'not-allowed' } : undefined}
            />
          </div>

          <div className="form-group">
            <label className="form-label">組織ID</label>
            <input
              type="text"
              value={organization.id}
              disabled
              className="form-input font-mono text-sm"
              style={{ background: 'var(--color-surface)', color: 'var(--color-text-secondary)', cursor: 'not-allowed' }}
            />
          </div>

          {editingOrg && (
            <div className="flex justify-end gap-3 pt-4" style={{ borderTop: '1px solid var(--color-border-light)' }}>
              <button
                onClick={() => {
                  setEditingOrg(false)
                  setOrgName('')
                  setOrgDescription('')
                }}
                className="btn btn-outline"
              >
                キャンセル
              </button>
              <button
                onClick={async () => {
                  try {
                    await updateOrganization.mutateAsync({
                      name: orgName,
                      description: orgDescription
                    })
                    setEditingOrg(false)
                    alert('組織情報を更新しました')
                  } catch (error) {
                    alert(error instanceof Error ? error.message : '組織情報の更新に失敗しました')
                  }
                }}
                className="btn btn-primary"
              >
                保存
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="card text-center" style={{ padding: 'var(--space-12)' }}>
          <p className="text-sm text-secondary">組織情報が見つかりません</p>
        </div>
      )}
    </div>
  )
}
